import { AutoComplete, Input } from 'antd';
import { useMemo } from 'react';
import { IoLocationSharp } from 'react-icons/io5';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';

interface SearchLocationProps {
    updateLocation: (location: { center: { lat: number; lng: number }; zoom: number }) => void;
    setDefaultLocation: () => void;
    isLoading?: boolean;
}

const { Search } = Input;

const SearchLocation: React.FC<SearchLocationProps> = ({ updateLocation, setDefaultLocation, isLoading }) => {
    const {
        suggestions: { data, loading },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        debounce: 300,
    });

    const handleSearch = (newValue: string) => {
        setValue(newValue);
    };

    const handleSelect = (description: string) => {
        setValue(description, false);
        clearSuggestions();

        getGeocode({ address: description }).then(async (results) => {
            const { lat, lng }: any = await getLatLng(results[0]);
            updateLocation({
                center: { lat, lng },
                zoom: 12,
            });
        });
    };

    const handleChange = (value: string) => {
        if (value === '') {
            setDefaultLocation();
        }
    };

    const searchResult = useMemo(() => data.map((place: any) => ({
        value: place.description,
        label: (
            <div>
                <IoLocationSharp style={{ marginRight: 8 }} scale={10} />
                {place.description}
            </div>
        ),
    })), [data]);

    return (
        <AutoComplete
            options={searchResult}
            onSelect={handleSelect}
            style={{ width: '100%' }}
            defaultActiveFirstOption
            onSearch={handleSearch}
            onChange={handleChange}
            disabled={isLoading}
        >
            <Search
                placeholder="Av. 123..."
                enterButton
                style={{ border: 'none' }}
                loading={loading || isLoading}
                disabled={isLoading}
            />
        </AutoComplete>
    );
};

export default SearchLocation;
